import React from 'react';
import { Apple, Music } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faSpotify } from '@fortawesome/free-brands-svg-icons'; // Spotify
import { faApple } from '@fortawesome/free-brands-svg-icons'; // Apple (generic)


const SparkParticle = ({ delay }) => {
  return (
    <div
      className="absolute w-1 h-1 bg-red-500 rounded-full opacity-0"
      style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animation: `spark 3s infinite`,
        animationDelay: `${delay}s`,
      }}
    />
  );
};

const AboutPage = ({ id }) => {
  const sparkCount = 30;
  const sparks = Array.from({ length: sparkCount }, (_, i) => (
    <SparkParticle key={i} delay={Math.random() * 2} />
  ));

  return (
    <section id={id} className="bg-black/90 py-12">
      <style>{`
        @keyframes spark {
          0% { 
            transform: translate(0, 0) scale(0);
            opacity: 0;
          }
          50% { 
            transform: translate(${Math.random() * 100 - 50}px, ${Math.random() * 100 - 50}px) scale(1);
            opacity: 0.8;
          }
          100% { 
            transform: translate(${Math.random() * 200 - 100}px, ${Math.random() * 200 - 100}px) scale(0);
            opacity: 0;
          }
        }
      `}</style>
      <div className="absolute inset-0 pointer-events-none">
        {sparks}
      </div>

      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-6 text-lg text-white/80">
            <p className="text-xl font-medium text-white">
              A reimagining of one of the oldest hero's journeys of all time.
            </p>
            
            <p>
              <span className="text-red-400 font-semibold">EPIC</span> is a groundbreaking musical adaptation of Homer's The Odyssey, 
              where classical storytelling meets modern entertainment. Drawing inspiration from video games and anime, 
              the production creates a unique fusion of ancient mythology and contemporary artistry. Available now on all major music streaming platforms.
            </p>

            {/* Streaming Platform Links */}
            <div className="flex flex-col items-center justify-center pt-8 pb-4 space-y-3">
              <div className="flex flex-col sm:flex-row gap-6">
                {/* Spotify Button */}
                <a 
                  href="https://open.spotify.com/playlist/3sdEH7HfFE3d4xry5RnnLr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-3 px-8 py-4 bg-[#1DB954] hover:bg-[#1ed760] transition-colors duration-300 rounded-lg group min-h-[64px]"
                >
                    <FontAwesomeIcon icon={faSpotify} size="2x" />
                  <span className="text-xl font-semibold leading-none">Spotify</span>
                </a>

                {/* Apple Music Button */}
                <a 
                  href="https://music.apple.com/rs/artist/jorge-rivera-herrans/1660193130"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 px-8 py-4 bg-[#FB233B] hover:bg-[#ff2d44] transition-colors duration-300 rounded-lg group"
                >
                    <FontAwesomeIcon icon={faApple} size="2x" />

                  <span className="text-xl font-semibold">Apple Music</span>
                </a>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mt-12">
              <div className="bg-white/5 p-6 rounded-lg backdrop-blur-sm">
                <h2 className="text-xl font-semibold text-white mb-4">The Journessy</h2>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="text-red-400 mr-2">•</span>
                    40 songs, completely sung-through
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-400 mr-2">•</span>
                    Divided into 9 sagas, ala Ancient Greek plays
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-400 mr-2">•</span>
                    5 sagas in Act 1, 4 sagas in Act 2
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-400 mr-2">•</span>
                    Total runtime: 2 hours 16 minutes
                  </li>
                </ul>
              </div>

              <div className="bg-white/5 p-6 rounded-lg backdrop-blur-sm">
                <h2 className="text-xl font-semibold text-white mb-4">Siren-esque Songs</h2>
                <p className="leading-relaxed">
                  As the story progresses into more magical and divine realms, 
                  the music evolves to incorporate increasingly electronic elements, 
                  creating a unique soundscape that mirrors the journey's supernatural transformation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPage;